import { useEffect, useState } from "react";

const EKGAnimation = () => {
  return (
    <div className="h-96  overflow-hidden flex items-center justify-center p-5 mt-40">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 500 200"
        className="relative transition-all duration-500 
        ease-in-out mx-5"
      >
        <polyline
          points="486.6,113.8 328.2,113.8 310.3,132.3 296,70.7 246.8,127.4 241.6,120.2 233.9,166.4 227,27.6 213.2,118.3 211.8,112.3 205.1,126.1 198.2,108.5 194.1,124.4 184.5,92.9 174.1,113 4.3,113"
          className="fill-none stroke-green-200 stroke-[1] 
          stroke-round opacity-0 animate-ekg"
        />
      </svg>
      <style>
        {`
          @keyframes ekg {
            0% {
              opacity: 0;
            }
            25% {
              opacity: 1;
            }
            50% {
              stroke-dashoffset: 2000;
            }
            99% {
              opacity: 0;
              stroke-dashoffset: 3000;
            }
            100% {
              stroke-dashoffset: 1000;
            }
          }
          .animate-ekg {
            stroke-dasharray: 1000;
            stroke-dashoffset: 1000;
            animation: ekg 7s linear forwards infinite;
          }
        `}
      </style>
    </div>
  );
};

export default EKGAnimation;
